import { render, staticRenderFns } from "./SoftwareActivate.vue?vue&type=template&id=5912b068"
import script from "./SoftwareActivate.vue?vue&type=script&lang=js"
export * from "./SoftwareActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports